import { render, staticRenderFns } from "./AddGroups.vue?vue&type=template&id=26d7cbd8&scoped=true&"
import script from "./AddGroups.vue?vue&type=script&lang=js&"
export * from "./AddGroups.vue?vue&type=script&lang=js&"
import style0 from "./AddGroups.vue?vue&type=style&index=0&id=26d7cbd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7cbd8",
  null
  
)

export default component.exports